export default {"src":"/_next/static/media/laptop-moderate.c697263d.svg","height":67,"width":99};